import {DEFAULT_LOCATION_NAME} from 'modules/locations/constants';
import {useUserLocation} from 'modules/locations/hooks/useUserLocation';
import React, {memo} from 'react';

export const LocationName = memo(() => {
    const userLocation = useUserLocation();

    return <>{userLocation?.title ?? DEFAULT_LOCATION_NAME}</>;
});
